import { useEffect, useState } from "react";
import Button from "../../../common/Button";
import { HiOutlinePlus } from "react-icons/hi";
import { MdClose } from "react-icons/md";
import { LiaSearchPlusSolid } from "react-icons/lia";
import Table from "../../../common/Table";
import Loader from "../../../common/Loader";
import { notify } from "../../../common/Toast";
import {
  MenuMasterAPI,
  MenuPermissionAPI,
  UsersAPI,
} from "../../../utlis/apiService";
import Pagination from "../../../common/Pagination";
import ConfirmDeleteModal from "../../../common/DeleteModel";
import ErrorModal from "../../../common/CustomModel";
import Model from "../../../common/Model";
import MenuPermissionForm from "./MenuPermissionForm";

const MenuPermission = () => {
  //   const userId = sessionStorage.getItem("userId");
  const [searchQuery, setSearchQuery] = useState("");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({
    menuId: [],
  });
  const [loading, setLoading] = useState(false);
  const [isMenusData, setIsMenusData] = useState([]);
  const [isUserData, setIsUserData] = useState([]);
  const [isMenuIDSData, setIsMenuIDSData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const pageSize = 10;

  const fetchMenusData = async () => {
    setLoading(true);
    try {
      const res = await MenuPermissionAPI.getAllPagination(
        currentPage,
        pageSize
      );
      setIsMenusData(res.data || []);
      setFilteredData(res.data || []);
      setTotalRecords(res.totalCount || res.data?.length || 0);
    } catch (error) {
      notify("Error fetching location data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchMenusData();
    fetchUserData();
    fetchMenusIDSData();
  }, [currentPage]);

  const fetchUserData = async () => {
    try {
      const res = await UsersAPI.getAll();
      setIsUserData(res.map((d) => ({ value: d.user_Id, label: d.userName })));
    } catch (error) {
      notify("Error fetching location data", "error");
    }
  };

  const fetchMenusIDSData = async () => {
    try {
      const res = await MenuMasterAPI.getAll();
      setIsMenuIDSData(
        res.map((d) => ({ value: d.menu_ID, label: d.menu_Name }))
      );
    } catch (error) {
      notify("Error fetching location data", "error");
    }
  };

  const handleAdd = () => {
    setIsModelOpen(true);
  };

  const handleEdit = async (userId) => {
    try {
      const data = await MenuPermissionAPI.getById(userId);
      if (data && data.length > 0) {
        setFormData({
          userId: data[0].userId,
          permissions: data.map((item) => ({
            menuId: item.menuId,
            insert: item.isInsert,
            update: item.isUpdate,
            delete: item.isDelete,
            view: item.isView,
          })),
        });
      }
      setIsEditing(true);
      setIsModelOpen(true);
    } catch (error) {
      notify("Failed to fetch menu permission", "error");
    }
  };

  const handleDelete = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await MenuPermissionAPI.delete(selectedId);
      notify("Deleted successfully", "success");
      fetchMenusData();
    } catch (error) {
      notify("Failed to delete record", "error");
    }
    setIsDeleteModalOpen(false);
    setSelectedId(null);
  };

  const handleSave = async (payload) => {
    try {
      await MenuPermissionAPI.saveOrUpdate(payload);
      setIsModelOpen(false);
      fetchMenusData();
      notify("Saved successfully", "success");
    } catch {
      notify("Failed to save", "error");
    }
  };

  return (
    <>
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5  mt-10 ">
        <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
          <div className="relative w-full sm:w-1/2 lg:w-1/3">
            <input
              type="text"
              className="w-full bg-gray-100 border border-gray-3 py-2 pl-10 pr-10 rounded-md focus:ring-1 focus:ring-primary focus:border-primary outline-none"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Button
              icon={LiaSearchPlusSolid}
              iconSize="w-5 h-5"
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary"
            ></Button>
            {searchQuery && (
              <Button
                icon={MdClose}
                onClick={() => setSearchQuery("")}
                iconSize="w-5 h-5"
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-danger"
              ></Button>
            )}
          </div>
          <Button
            text="Set Menu-Permission"
            className="bg-orange text-black font-semibold text-md rounded-md p-2"
            iconSpacing="pr-1"
            icon={HiOutlinePlus}
            iconSize="w-4 h-4"
            iconColor="text-black"
            onClick={handleAdd}
          />
        </div>
        {loading ? (
          <Loader />
        ) : (
          <Table
            columns={[
              { key: "user_Name", label: "User Name" },
              { key: "menuNames", label: "Menu Name" },
            ]}
            data={isMenusData}
            onEdit={(row) => handleEdit(row.userId)}
            onDelete={(row) => handleDelete(row.userId)}
          />
        )}
        <div className="flex justify-center items-center mt-4">
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(totalRecords / pageSize)}
            onPageChange={setCurrentPage}
          />
        </div>
        <Model
          isOpen={isModelOpen}
          onClose={() => setIsModelOpen(false)}
          name={"Add Menu Permission"}
        >
          <MenuPermissionForm
            isUserData={isUserData}
            isMenuIDSData={isMenuIDSData}
            onCancel={() => setIsModelOpen(false)}
            onSubmit={handleSave}
            isEditing={isEditing}
            formData={formData}
          />
        </Model>
      </div>
      <ConfirmDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
      />
      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}
    </>
  );
};

export default MenuPermission;
